// $(document).ready(function() {
//     $('.teaseTrigger').click(function(e) {
//         var t = $(e.target).closest('.article');
//         if (t.length) {
//             var a = t.find('.content'),
//                 i = t.find('.content_inner'),
//                 r = t.find('.desktopExpandWrap');
//             a.css('max-height', i.height()),
//                 r.css('opacity', 0),
//                 r.css('visibility', 'hidden'),
//                 window.setTimeout(function() {
//                     t.addClass('expanded');
//                 }, 300);
//         }
//     });
// });

function closest(el, className) {
    let parent;

    // traverse parents
    while (el) {
        parent = el.parentElement;
        if (parent && parent.className.split(' ').indexOf(className) !== -1) {
            return parent;
        }
        el = parent;
    }

    return null;
}

const teaserExpand = (e) => {
    const article = closest(e.target, 'js-article');

    if (article) {
        e.preventDefault();
        const contentInner = article.getElementsByClassName('js-contentInner')[0];
        const articleHeight = contentInner.offsetHeight + 30 + 'px'; // 30px padding
        const content = article.getElementsByClassName('js-content')[0];
        const expandWrap = article.getElementsByClassName('js-expandWrap')[0];

        content.style.maxHeight = articleHeight;
        expandWrap.style.opacity = 0;
        expandWrap.style.visibility = 'hidden';
        window.setTimeout(() => {
            article.className += ' expanded'
            article.setAttribute("expanded","true")
            content.style.maxHeight = '';
        }, 300);
    }
}

const teaserInit = () => {
    const eles = document.getElementsByClassName('js-teaseTrigger');
    for (let i = 0, len = eles.length; i < len; i++) {
        eles[i].addEventListener('click', teaserExpand);
    }
}

if (document.readyState != 'loading') {
    teaserInit();
} else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', teaserInit);
} else {
    document.attachEvent('onreadystatechange', function() {
        if (document.readyState != 'loading') teaserInit();
    });
}